import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { useWinCelebrations } from "@/hooks/useEngagement";
import { fmtUsd } from "@/lib/format";
import { useAssetName } from '@/lib/instruments';

/** Mounted once in the layout: celebrates winning closes (hooks/useEngagement). */
export function WinCelebrations() {
  const { t } = useTranslation("common");
  const an = useAssetName();
  useWinCelebrations(({ symbol, pnl, session }) => {
    toast.success(t("celebrate.winTitle"), {
      description: t("celebrate.winBody", { symbol: an(symbol), pnl: fmtUsd(pnl, 2, { sign: true }), session }),
      duration: 6000,
      // No "Mute sounds" button here (Guillaume, round 12): sound is a setting, not a pop-up action.
    });
  });
  return null;
}
